module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/analysis-e9b6106cc933475c461cee3a9e49cf2d.png";